import Component from './NavMenu.vue';

export default {
  install(Vue) {
    Vue.component('BkfVNavmenu', Component);
  },
};
